var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"QueryWidget"},[(_vm.q.structuredQuery)?_vm._l((_vm.q.structuredQuery.rows),function(sq,sKey){return _c('span',{key:sKey},[(sq.operator)?_c('span',[_vm._v(_vm._s(sq.operator))]):_vm._e(),_c('span',[_vm._v(_vm._s(sq.query))])])}):[_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatQueryNotions(_vm.q.query))}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }